import { app } from '@/core/firebase'

class FirebaseAuthentication {
  constructor(client) {
    this.client = client
  }

  getUid() {
    return this.client.currentUser.uid
  }

  async createUser(email, password) {
    const credential = await this.client.createUserWithEmailAndPassword(email, password)
    return credential.user
  }

  async deleteUser(email, password) {
    let user = this.authClient.currentUser
    try {
      return await user.delete()
    } catch(e) {
      const credential = await this.reauthenticate(email, password)
      return await credential.user.delete()
    }
  }

  async signIn(email, password) {
    return await this.client.signInWithEmailAndPassword(email, password)
  }

  async signOut() {
    return await this.client.signOut()
  }

  async sendEmailVerification(url) {
    const actionCodeSettings = {
      url: url,
      handleCodeInApp: true
    }
    return await this.client.currentUser.sendEmailVerification(actionCodeSettings)
  }

  async sendPasswordResetEmail(email) {
    return await this.client.sendPasswordResetEmail(email)
  }

  async reauthenticate(email, password) {
    let user = this.client.currentUser
    return await user.reauthenticateWithCredential(this.client.EmailAuthProvider.credential(email, password))
  }
  
}

const auth = new FirebaseAuthentication(app.auth())

export { auth }